const visibleServiceRoleStatuses = new Set([
  'INITIATED',
  'IN_APPROVAL',
  'CLARIFICATION_NEEDED',
  'ACTIVE',
  'APPROVED',
  'VALIDATION_COMPLETED',
  'IN_VALIDATION',
]);

type ServiceRoleWithStatus = {
  status?: string | null;
};

export const isVisibleServiceRoleStatus = (status: string | null | undefined) =>
  typeof status === 'string' && visibleServiceRoleStatuses.has(status);

export const filterVisibleServiceRoles = <T extends ServiceRoleWithStatus>(serviceRoles?: T[] | null): T[] =>
  serviceRoles?.filter((serviceRole) => isVisibleServiceRoleStatus(serviceRole.status)) ?? [];
